module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainpage"
  }, [_c('a-layout', {
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "components-layout-demo-side"
    }
  }, [_c('menuBar', {
    attrs: {
      "current": _vm.current,
      "openKeys": _vm.openKeys
    }
  }), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('topBar', {
    attrs: {
      "fatherMethod": _vm.initialize
    }
  }), _vm._v(" "), (!_vm.isfinish) ? _c('a-layout-content', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20%"
    }
  }, [_c('a-spin', {
    attrs: {
      "tip": "Loading...",
      "size": "large"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isfinish) ? _c('a-layout-content', {
    staticStyle: {
      "margin": "16px",
      "min-width": "1192px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "line-height": "30px",
      "margin-bottom": "10px",
      "font-weight": "700",
      "padding-left": "8px"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('div', [_c('a-row', {
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "gutter": 16
    }
  }, [_c('a-col', {
    staticClass: "datalist",
    attrs: {
      "span": 6
    }
  }, [_c('div', [_c('span', {
    staticClass: "title"
  }, [_vm._v("总销售额")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        return _vm.gotopage('saleslist')
      }
    }
  }, [_vm._v("详情")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("￥" + _vm._s(_vm.tradeAll.totalPrice / 100))])]), _vm._v(" "), _c('a-rate', {
    attrs: {
      "defaultValue": 5,
      "disabled": ""
    }
  }), _vm._v(" "), _c('a-divider', {
    staticStyle: {
      "margin": "0"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "6px",
      "font-size": "14px",
      "color": "#666"
    }
  }, [_c('span', [_vm._v("今日销售额 ¥ " + _vm._s(_vm.tradeAll.totalPriceNow / 100))])])], 1)]), _vm._v(" "), _c('a-col', {
    staticClass: "datalist",
    attrs: {
      "span": 6
    }
  }, [_c('div', [_c('span', {
    staticClass: "title"
  }, [_vm._v("总访问量")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("详情")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("8,846(拟)")])]), _vm._v(" "), _c('a-rate', {
    attrs: {
      "defaultValue": 5,
      "disabled": ""
    }
  }), _vm._v(" "), _c('a-divider', {
    staticStyle: {
      "margin": "0"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "6px",
      "font-size": "14px",
      "color": "#666"
    }
  }, [_c('span', [_vm._v("今日访问量 ¥ 1,423(拟)")])])], 1)]), _vm._v(" "), _c('a-col', {
    staticClass: "datalist",
    attrs: {
      "span": 6
    }
  }, [_c('div', [_c('span', {
    staticClass: "title"
  }, [_vm._v("订单笔数")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        return _vm.gotopage('transactionlist')
      }
    }
  }, [_vm._v("详情")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm.tradeAll.sum))])]), _vm._v(" "), _c('a-rate', {
    attrs: {
      "defaultValue": 5,
      "disabled": ""
    }
  }), _vm._v(" "), _c('a-divider', {
    staticStyle: {
      "margin": "0"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "6px",
      "font-size": "14px",
      "color": "#666"
    }
  }, [_c('span', [_vm._v("转化率 " + _vm._s(Math.ceil((_vm.tradeAll.sumNow / _vm.tradeAll.sum) * 10 * 10)) + "%")])])], 1)]), _vm._v(" "), _c('a-col', {
    staticClass: "datalist",
    attrs: {
      "span": 6
    }
  }, [_c('div', [_c('span', {
    staticClass: "title"
  }, [_vm._v("服务费")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        return _vm.gotopage('servicelist')
      }
    }
  }, [_vm._v("详情")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("￥" + _vm._s(_vm.tradeAll.sumServiceFee / 100000))])]), _vm._v(" "), _c('a-progress', {
    attrs: {
      "percent": 78,
      "size": "small",
      "status": "active",
      "showInfo": false,
      "strokeLinecap": "square",
      "strokeColor": "#13c2c2"
    }
  }), _vm._v(" "), _c('a-divider', {
    staticStyle: {
      "margin": "0"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "6px",
      "font-size": "14px",
      "color": "#666"
    }
  }, [_c('span', [_vm._v("今日服务费 ￥ " + _vm._s(_vm.tradeAll.sumServiceFeeNow / 100000))])])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "line-height": "30px",
      "margin-bottom": "10px",
      "color": "#666",
      "padding-left": "8px",
      "margin-top": "10px"
    }
  }, [_vm._v("订单管理")]), _vm._v(" "), _c('a-row', [_c('a-col', {
    staticClass: "orderlist",
    attrs: {
      "span": 4
    },
    on: {
      "click": function($event) {
        return _vm.gototransactionlist('all')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('span', {
    staticClass: "hovernum",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm.tradeInfo.sum))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "hovertitle",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "700"
    }
  }, [_vm._v("全部")])])]), _vm._v(" "), _c('a-col', {
    staticClass: "orderlist",
    attrs: {
      "span": 4
    },
    on: {
      "click": function($event) {
        return _vm.gototransactionlist('to_be_paid')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('span', {
    staticClass: "hovernum",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm.tradeInfo.to_be_paid))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "hovertitle",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "700"
    }
  }, [_vm._v("待付款")])])]), _vm._v(" "), _c('a-col', {
    staticClass: "orderlist",
    attrs: {
      "span": 4
    },
    on: {
      "click": function($event) {
        return _vm.gototransactionlist('have_paid')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('span', {
    staticClass: "hovernum",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm.tradeInfo.have_paid))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "hovertitle",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "700"
    }
  }, [_vm._v("待发货")])])]), _vm._v(" "), _c('a-col', {
    staticClass: "orderlist",
    attrs: {
      "span": 4
    },
    on: {
      "click": function($event) {
        return _vm.gototransactionlist('delivery')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('span', {
    staticClass: "hovernum",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm.tradeInfo.delivery))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "hovertitle",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "700"
    }
  }, [_vm._v("已发货")])])]), _vm._v(" "), _c('a-col', {
    staticClass: "orderlist",
    attrs: {
      "span": 4
    },
    on: {
      "click": function($event) {
        return _vm.gototransactionlist('finished')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('span', {
    staticClass: "hovernum",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm.tradeInfo.finished))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "hovertitle",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "700"
    }
  }, [_vm._v("已完成")])])]), _vm._v(" "), _c('a-col', {
    staticClass: "orderlist",
    attrs: {
      "span": 4
    },
    on: {
      "click": function($event) {
        return _vm.gototransactionlist('refund')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('span', {
    staticClass: "hovernum",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm.tradeInfo.refund))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "hovertitle",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "700"
    }
  }, [_vm._v("申请退款售后")])])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "background-color": "white"
    }
  }, [_c('a-tabs', {
    attrs: {
      "size": "large"
    }
  }, [_c('a-tab-pane', {
    key: "1",
    attrs: {
      "tab": "销售额"
    }
  }, [(_vm.sourcedata) ? _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "overflow": "hidden"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "40px",
      "color": "#000"
    }
  }, [_vm._v("销售额趋势")]), _vm._v(" "), _c('v-chart', {
    attrs: {
      "height": 300,
      "width": 1200,
      "data": _vm.sourcedata,
      "scale": _vm.scale
    }
  }, [_c('v-tooltip'), _vm._v(" "), _c('v-axis'), _vm._v(" "), _c('v-legend'), _vm._v(" "), _c('v-stack-bar', {
    attrs: {
      "position": 'title*sales',
      "color": 'apps_name'
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('a-tab-pane', {
    key: "2",
    attrs: {
      "tab": "访问量",
      "disabled": ""
    }
  }, [(_vm.sourcedata) ? _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "overflow": "hidden",
      "height": "300px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "40px",
      "color": "#000"
    }
  }, [_vm._v("访问量趋势")]), _vm._v(" "), _c('v-chart', {
    attrs: {
      "height": 300,
      "width": 1200,
      "data": _vm.sourcedata,
      "scale": _vm.linescale
    }
  }, [_c('v-tooltip'), _vm._v(" "), _c('v-axis'), _vm._v(" "), _c('v-line', {
    attrs: {
      "position": "title*sales"
    }
  }), _vm._v(" "), _c('v-point', {
    attrs: {
      "position": "title*sales",
      "shape": "circle"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "8px 16px 0 0"
    },
    attrs: {
      "slot": "tabBarExtraContent"
    },
    slot: "tabBarExtraContent"
  }, [_c('a-radio-group', {
    attrs: {
      "defaultValue": "year",
      "value": _vm.timevalue
    },
    on: {
      "change": _vm.ontimeChange
    }
  }, [_c('a-radio-button', {
    attrs: {
      "value": "day"
    }
  }, [_vm._v("今日")]), _vm._v(" "), _c('a-radio-button', {
    attrs: {
      "value": "week"
    }
  }, [_vm._v("本周")]), _vm._v(" "), _c('a-radio-button', {
    attrs: {
      "value": "month"
    }
  }, [_vm._v("本月")]), _vm._v(" "), _c('a-radio-button', {
    attrs: {
      "value": "year"
    }
  }, [_vm._v("全年")])], 1), _vm._v(" "), _c('a-range-picker', {
    attrs: {
      "defaultValue": [_vm.moment(_vm.startdate, _vm.dateFormat), _vm.moment(_vm.enddate, _vm.dateFormat)]
    },
    on: {
      "change": _vm.onChangeTime
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('bottomBar')], 1)], 1), _vm._v(" "), _c('div', [_c('a-back-top')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f6f4568","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/mainpage/index.vue
// module id = 2396
// module chunks = 1